    /* 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               NonEMB Monogrampreview for all monograms that only have Perview; preview is just a dropdown of these static embroidery designs.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
    $(function() {

        //Start variables needed:
        var debug;
        var ShirtColor;
        var firstMonoLink;
        var secondMonoLinkImage;
        var soldMonoLink;
        var sendImg;
        var soldImage;
        var extractImage;
        var MonogramText;
        var threadcolor;
        var MonogramFont;
        var imagesize;
        var typingTimer;
        var doneTypingInterval = 1200;
        var mono_server;
        var errorDetails;
        var flagStop;
        var bordercolor;
        var heartcolor;
        var pawcolor;
        var Logocolor;
        var mono_server;
        //End of Variables



        //-----------------------------------
        //Button from the main product page
        //-----------------------------------
        $('#preview-monogram').on('click', function(el) {
            //old monogramtext check effect $('input[name="properties[Monogram (first, LAST NAME, middle)]"]').val();
            //old threadcolor = $('select[name="properties[Thread Color]"]').find(':selected').attr('data-valcolor');
            MonogramText = $('input#MonogramText').val();
     
            threadcolor = $("#threadcolor option:selected").attr("data-valcolor");
            MonogramFont = $('select[name="properties[Your Pick]"]').find(':selected').attr('data-valname');
            ///for debugging 
            //  debug = $('select[name="properties[MonogramFont]"]').find(':selected').attr('data-valname');
            //$("#debug").html(debug);
            ///for debugging

   
        

            // Function to simplify setting HTML content based on MonogramFont
            const setImageMonoDisplay = (key) => {
                const matchedKey = Object.keys(gloEmbMonogramCodelist).find(k => key.includes(k));
                if (matchedKey) {
                    const { src = '', code = '' } = gloEmbMonogramCodelist[matchedKey];


                    if (dec(code) === matchedKey) {
                        $("#monogramimage").html(`<img id='monogramImg' class='line-item-property__field w3-padding-48' style='object-fit: fill' alt='Monogram here' src='${src}' />`);
                        return;
                    }
                }
                // Default image if no match is found
                $("#monogramimage").html("<img id='monogramImg' class='line-item-property__field w3-padding-48' style='object-fit: fill' alt='Monogram here' src='//cdn.shopify.com/s/files/1/0054/6819/2886/files/ABC_Black.png?v=1596808745' />");
            };


            //-----------------------------------
            ///Trigger call to monogram's default value
            //-----------------------------------     
            //--------------------------------------------
            //--------Different default display setting    
            //Removed w3-margin  to center the big image
            //--------------------------------------------
 
            setImageMonoDisplay(MonogramFont);

            // if (MonogramFont.indexOf("101MRatherBe") != -1) { //MWL02262022
            //     setImageMonoDisplay("101MRatherBe");
  
            // } else if (MonogramFont.indexOf("101MTarget") != -1) { //MWL02262022
            //     setImageMonoDisplay("101MTarget");
   
            // } else if (MonogramFont.indexOf("101MStarbucks") != -1) { //MWL02262022
            //     setImageMonoDisplay("101MStarbucks");
    
            // } else if (MonogramFont.indexOf("71MClassicSmiley") != -1) { //MWL02262022
            //      setImageMonoDisplay("71MClassicSmiley");

            // } else if (MonogramFont.indexOf("304MHappy") != -1) { //MWL02262022
            //     setImageMonoDisplay("304MHappy");

            // } else if (MonogramFont.indexOf("254MCharleston") != -1) { //MWL02262022
            //      setImageMonoDisplay("254MCharleston");

            // } else if (MonogramFont.indexOf("89MCHS") != -1) { //MWL02262022
            //      setImageMonoDisplay("89MCHS");

            // } else if (MonogramFont.indexOf("101MGoodEnergyClub") != -1) { //MWL02262022
            //      setImageMonoDisplay("101MGoodEnergyClub");
 
            // } else if (MonogramFont.indexOf("254IcedCaramel") != -1) { //MWL03272022
            //      setImageMonoDisplay("254IcedCaramel");
 
            // } else if (MonogramFont.indexOf("101MAngelNumbers") != -1) { //MWL03272022
            //      setImageMonoDisplay("101MAngelNumbers");

            // } else if (MonogramFont.indexOf("177MRatherXmas") != -1) { //MWL02262022
            //    setImageMonoDisplay("177MRatherXmas");

            // } else if (MonogramFont.indexOf("101MDisney") != -1) { //MWL02262022
            //      setImageMonoDisplay("101MDisney");

            // } else if (MonogramFont.indexOf("177MWifey") != -1) { //MWL02262022
            //      setImageMonoDisplay("177MWifey");

            // } else if (MonogramFont.indexOf("101MVinSanta1") != -1) { //MWL02262022
            //      setImageMonoDisplay("101MVinSanta1");

            // } else if (MonogramFont.indexOf("101MGrCoke") != -1) { //JDG11042023
            //      setImageMonoDisplay("101MGrCoke");
 
            // } else if (MonogramFont.indexOf("101MGCoke") != -1) { 
            //     setImageMonoDisplay("101MGCoke");

            // } else if (MonogramFont.indexOf("101MFloralLetter") != -1) {
            //     setImageMonoDisplay("101MFloralLetter");

            // } else if (MonogramFont.indexOf("200MCozy") != -1) {

            //     setImageMonoDisplay("200MCozy");

            // } else {
            //    // alert(MonogramFont);
            //     $("#monogramimage").html("<img id='monogramImg'   class='line-item-property__field    w3-padding-48 ' style='  object-fit: fill'    alt='Monogram here'  src='//cdn.shopify.com/s/files/1/0054/6819/2886/files/ABC_Black.png?v=1596808745'    />");
            // }






            //-----------------------------------
            ///End generate monogram default
            //-----------------------------------

            //-----------------------------------
            //---disable the add to cart button and show the pop-up
            //-----------------------------------
            $("#modal").show(500);
            $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
        });



        //-----------------------------------
        //---------Check all the selections to trigger the Generate monogram
        //------------------------------------Start
        //Detect changes in all the select buttons
        $('select').on('change', function() {
            delayExecute();
        });

        //Detect values input in the textbox
        $('input#MonogramText').on('keydown', function(event) {
            delayExecute();

        });

        //-----------------------------------  
        //Detect keystroke and only execute after the user has finish typing
        //-----------------------------------
        function delayExecute() {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(
                function() {
                    GenerateMonogram()
                },
                doneTypingInterval
            );
            return true;
        }
        //-----------------------------------
        //------------------------------------End
        //-----------------------------------

        //-----------------------------------  
        //cater different logocolors and monogram server
        //-----------------------------------
        function LogoColor_Server(Logocolor, mono_server) {
            logoColor = Logocolor;
            mono_server = mono_server;
            return true;
        }
        //-----------------------------------
        //------------------------------------End
        //-----------------------------------

        //-----------------------------------
        //Generate the Customers monogram
        //-----------------------------------  
        function GenerateMonogram() {
            //Get all the value passed
            //MonogramText = $('input#MonogramText').val();
            threadcolor = $("#threadcolor option:selected").attr("data-valcolor");
            MonogramFont = $('select[name="properties[Your Pick]"]').find(':selected').attr('data-valname');
            //For No Monograms SKU, checks last 2 letters. 
            if (MonogramFont.slice(-2) == "No") {
                MonogramText = "***";
                $("#MonogramText").val('');
            } else {
                MonogramText = $('input#MonogramText').val();
            }

            //reset the error display
            $("#validatorId").html("");
            flagStop = "";
            $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');


            //Validation before creating the monogrammed.
            //-----------------------------------
            if (MonogramText !== "" && threadcolor !== "" && typeof threadcolor !== 'undefined' && MonogramFont !== "" && typeof MonogramFont !== 'undefined') {



                if (MonogramFont.indexOf("101MCL") != -1) {
                    logoColor = "&Logocolors=A00704a,Affffff";
                    mono_server = "stitchdynamics5";

                } else if (MonogramFont.indexOf("177MRatherXmas") != -1) {
                    logoColor = "&Logocolors=" + threadcolor;
                    mono_server = "stitchdynamics5";

                    ///start--For 101MGoodVibes selection ;added  JDG11012023 applied color fix
                } else if (MonogramFont.indexOf("101MGoodEnergyClub") != -1) {
                    LogoColor_Server("&Logocolors=ada7ca7,affffff,afbffaf", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MChooseHappy") != -1) {
                    LogoColor_Server("&Logocolors=aff55e2,aedcd1f,affdfed,ac5a432,af7b085", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MTakeItEasy") != -1) {
                    LogoColor_Server("&Logocolors=a000000,a6dcb97,ada7ca7,afbffaf", "stitchdynamics5");
                    ///End--For 101MGoodVibes selection 

                } else if (MonogramFont.indexOf("101MVinSanta1") != -1) {
                    LogoColor_Server("&Logocolors=afffcf8,afffcf8,afff2f5,aoooooo,ae72b2c,a3b9339,aoooooo,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MVinSanta2") != -1) {
                    LogoColor_Server("&Logocolors=aaa7347,aefdeb6,afff2f5,aoooooo,ae72b2c,a3b9339,aoooooo,ae72b2c,affffff,aoooooo", "stitchdynamics5");
 
                } else if (MonogramFont.indexOf("200MCozyMulti") != -1) {
                    LogoColor_Server("&Logocolors=adbc290,af2e8ec,af1e2c5,adbc290,af1e2c5,a2f8628,affffff,a000000", "stitchdynamics5");
                } else if (MonogramFont.indexOf("200MCozyOne") != -1) {
                    LogoColor_Server("&Logocolors=af1e2c5", "stitchdynamics5");

                    ///start--For Grinch Drinks 101MGrCoke selection ;   JDG11012023             
                } else if (MonogramFont.indexOf("101MGrCoke") != -1) {
                    if (MonogramFont.indexOf("Zero") != -1) { //101MGrCokeZero
                        LogoColor_Server("&Logocolors=aoooooo,a8acf6c,ab5b1ae,ab5b1ae,aoooooo,ae72b2c,affffff,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                    } else {
                        LogoColor_Server("&Logocolors=ae72b2c,a8acf6c,aafa9b1,aafa9b1,aoooooo,affffff,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                    }
                } else if (MonogramFont.indexOf("101MGrWine") != -1) {
                    LogoColor_Server("&Logocolors=A781818,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGrIcedCoffee") != -1) {
                    LogoColor_Server("&Logocolors=AA77D5B,ab5b1ae,a408a52,aoooooo,a8acf6c,ae72b2c,affffff,ab5b1ae,a408a52,aoooooo", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGrChick") != -1) {
                    LogoColor_Server("&Logocolors=a8acf6c,aoooooo,affffff,ae72b2c,aoooooo,ae72b2c,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGrSprite") != -1) {
                    LogoColor_Server("&Logocolors=a3b9339,a8acf6c,ab5b1ae,aoooooo,a8acf6c,ae72b2c,affffff,aoooooo,affffff,afff582,a8acf6c", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGrPepsi") != -1) {
                    LogoColor_Server("&Logocolors=a354ace,a8acf6c,ab5b1ae,aoooooo,ae72b2c,affffff,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGrMtDew") != -1) {
                    LogoColor_Server("&Logocolors=a8acf6c,ab5b1ae,affffff,a3b9339,aoooooo,a8acf6c,ae72b2c,affffff,aoooooo,a8acf6c,ae72b2c", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGrLaC") != -1) {
                    LogoColor_Server("&Logocolors=afff2f5,a2b2f8f,ac4deed,a8acf6c,ab5b1ae,aoooooo,a8acf6c,ae72b2c,affffff,aoooooo,a2b2f8f", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGrDrP") != -1) {
                    LogoColor_Server("&Logocolors=a862331,affffff,a8acf6c,ab5b1ae,aoooooo,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGrDiet") != -1) {
                    if (MonogramFont.indexOf("Drp") != -1) { //101MGrDietDrp
                        LogoColor_Server("&Logocolors=affffff,a862331,a8acf6c,ab5b1ae,aoooooo,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                    } else if (MonogramFont.indexOf("Pep") != -1) { //101MGrDietPep
                        LogoColor_Server("&Logocolors=ab5b1ae,a8acf6c,ab5b1ae,aoooooo,a3e4cb8,ae72b2c,affffff,a3e4cb8,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                    } else if (MonogramFont.indexOf("Coke") != -1) { //101MGrDietCoke
                        LogoColor_Server("&Logocolors=ab5b1ae,a8acf6c,ab5b1ae,aoooooo,ae72b2c,a8acf6c,ae72b2c,affffff,aoooooo", "stitchdynamics5");
                    }
        ///End--For Grinch Drinks 101MGrCoke selection ;   JDG11012023   

       ///start--For 101MGhost Drinks 101MGhost selection ;   JDG07312024             
                } else if (MonogramFont.indexOf("101MGCoke") != -1) {
                    if (MonogramFont.indexOf("Zero") != -1) { //101MGhost
                        LogoColor_Server("&Logocolors=affffff,a000000,aadadad,a000000,ae83d3d,affffff,aadadad,a000000", "stitchdynamics5");
                    } else {
                        LogoColor_Server("&Logocolors=affffff,ae83d3d,aadadad,a000000,affffff,a000000", "stitchdynamics5");
                    }
                } else if (MonogramFont.indexOf("101MGMtDew") != -1) {
                    LogoColor_Server("&Logocolors=affffff,aa0d579,aadadad,affffff,a397527,a000000,ae83d3d,a397527,a000000", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGPepsi") != -1) {
                    LogoColor_Server("&Logocolors=affffff,a2c3999,aadadad,a000000,a2c3999,ae83d3d,affffff", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGSprite") != -1) {
                    LogoColor_Server("&Logocolors=affffff,a2f8628,aadadad,a000000,afff281,a2f8628,affffff,a000000", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGChick") != -1) {
                    LogoColor_Server("&Logocolors=affffff,ae83d3d,a000000", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGWine") != -1) {
                    LogoColor_Server("&Logocolors=affffff,a792c1b,a000000", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGRedBull") != -1) {
                    LogoColor_Server("&Logocolors=affffff,a2c3999,aadadad,a000000,afff281,ae83d3d", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGAlani") != -1) {
                    LogoColor_Server("&Logocolors=affffff,aadadad,a000000,a49b49f", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGCelsius") != -1) {
                    LogoColor_Server("&Logocolors=affffff,aadadad,a000000,aadadad,aeb8637,a000000,aeb8637,a000000", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGCherryC") != -1) {
                    LogoColor_Server("&Logocolors=affffff,a792c1b,aadadad,a000000,ae83d3d,a2f8628,affffff,a000000", "stitchdynamics5");
               } else if (MonogramFont.indexOf("101MGDrPepper") != -1) {
                    LogoColor_Server("&Logocolors=affffff,a792c1b,aadadad,a000000,affffff,a000000", "stitchdynamics5");
               } else if (MonogramFont.indexOf("101MGIcedCoffee") != -1) {
                    LogoColor_Server("&Logocolors=affffff,ad1ab7e,affffff,aff83bd,affffff,a000000", "stitchdynamics5");
                } else if (MonogramFont.indexOf("101MGDiet") != -1) {
                    if (MonogramFont.indexOf("DP") != -1) { //101MGhost
                        LogoColor_Server("&Logocolors=affffff,aadadad,a792c1b,a000000", "stitchdynamics5");
                    } else if (MonogramFont.indexOf("Pepsi") != -1) { //101MGrDietPep
                        LogoColor_Server("&Logocolors=affffff,aadadad,aadadad,a000000,a2c3999,ae83d3d,affffff,a2c3999", "stitchdynamics5");
                    } else if (MonogramFont.indexOf("Coke") != -1) { //101MGrDietCoke
                        LogoColor_Server("&Logocolors=affffff,aadadad,a000000,aec522e,a000000", "stitchdynamics5");
                    }
         ///End--For 101MGhost Drinks 101MGhost selection ;   JDG07312024                          



                    
                } else if (MonogramFont.indexOf("101MFloralLetter") != -1) {
                    LogoColor_Server("&Logocolors=ac7dcb9,ae6bac9,af6dfe7,affffff,af0f2c0,ab6d1eb,af0f2c0,ae7ceeb,ac7dcb9", "stitchdynamics5");
                } else {
                    LogoColor_Server("", "stitchdynamics5");

                }


                //For Monograms without Logo Colors but requires Custom Colors
                if (MonogramFont.indexOf("SB101M2") != -1) { //MWL08062021
                    Color1 = threadcolor + "," + bordercolor;
                    mono_server = "stitchdynamics5";

                    if (MonogramText.length == 3) {
                        errorDetails = "Must have 2 letters for this Style";
                        $("#validatorId").html(" " + errorDetails + "").css("color", "red", "font-style", "italic");
                        flagStop = 1;
                    }
                } else if (MonogramFont.indexOf("71MFlower") != -1) { //MWL08062021
                    Color1 = threadcolor + ",afff856";
                    mono_server = "stitchdynamics5";

                } else if (MonogramFont.indexOf("71MClassicSmiley") != -1) { //MWL08062021
                    Color1 = threadcolor + ",a000000";
                    mono_server = "stitchdynamics5";

                } else if (MonogramFont.indexOf("304MHappy") != -1) { //MWL08062021
                    Color1 = "AD08AB3,Aff2a00,A6dcb97,A97ecff,affa2b8,Afbffaf,Af2caf0,Ada7ca7,a8ee9db,A40b4a5";
                    mono_server = "stitchdynamics5";


                } else {
                    Color1 = threadcolor;
                    mono_server = "stitchdynamics5";
                }


                //-----------------------------------
                ////---Details sent to lilo's server ^_^ ----------------------------
                //-----------------------------------

                if (flagStop != "1") { //------------------2 Letter

                    //-------UserAgreement changed 06/26 #JDG            
                    $("#UserAgreement").remove();
                    //-------UserAgreement changed 06/26 #JDG  

                    $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
                    //----Set a loader image..
                    $("#monogramimage").html("<img id='monogramImg'   class='line-item-property__field    w3-padding-48 ' style=' object-fit: cover'  alt='Monogram here'  src='//cdn.shopify.com/s/files/1/0635/8561/files/ajax-loading.gif?638'/>");

                    firstMonoLink = "https://" + mono_server + ".com/ecs/api/ecs/7?sku=" + MonogramFont + "&style=" + logoColor + "&pers1=" + encodeURIComponent(MonogramText) + "&color1=" + Color1;

                    //extract png file working
                    $.get(firstMonoLink, function(data, status) {
                        //alert("Data: " + data + "\nStatus: " + status);
                        sendImg = ("https://" + data);
                        //$("#debug").html(sendImg);
                        //passing of image and Image Display
                        $("#monogramimage").html("<img id='monogramImg'   class='line-item-property__field    w3-padding-48 '  style='  object-fit: fill'   alt='Monogram here'  src='" + sendImg + "'/>");

                        $("#hiddenMonogramImage").html("<input type='hidden'  name='properties[_MonogramImage]'    value='" + sendImg + "' />");
                        $("#monogramImg").on('load', function() {
                            //----Enable the add to cart button once image was successfully loaded
                            //alert("add to cart enabled");

                            //-------UserAgreement changed 06/26 #JDG    
                            addDivclassUserAgreement();
                            $('#addtocart').prop('disabled', false).removeClass('disabled');
                            //$('#addtocart').prop('disabled', false);
                            //----UserAgreement changed 06/26 #JDG  -----End 

                            //For No Monograms SKU, checks last 2 letters
                            if (MonogramFont.slice(-2) == "No") {
                                $("#MonogramText").attr('disabled', true);
                            }

                        });
                    });
                    /////---------Ending-----------------------  

                    // temp disable to check the missing images in the server
                    //  $('#addtocart').prop('disabled', false);

                }
                return; //------------------2 Letter             

            } else {
                //---These are blank values.

                if (MonogramText == "" && MonogramText !== "***") {
                    errorDetails = "input your Monogram";
                    $("#MonogramText").attr('disabled', false); //For No Monograms SKU
                } else if (threadcolor == "") {
                    errorDetails = "select a Threadcolor";
                } else {
                    errorDetails = "select Your Pick";
                }
                $("#validatorId").html("Please " + errorDetails + "").css("color", "red", "font-style", "italic");
            }

        }

        //----UserAgreement changed 06/26 #JDG  -----Start       
        //-------Function created for adding of divclass to avoid changing the all 100+ html templates 
        function addDivclassUserAgreement() { //replacing the code due to typo error
            $(".w3-containerw3-center").addClass("w3-container w3-center");
            $(".w3-containerw3-center").removeClass("w3-containerw3-center");


            $(".product__payment-container").css("display", "contents");
            $(".product__payment-container").prepend('<div  id="UserAgreement" style="font-size: 90%;display: contents;"><h4><input type="checkbox" id="uaID" name="UserAccept"/> I understand that <b><i>no changes</i></b> can be made to my order once it is submitted. I have reviewed every part of my order: item, color, size, monogram, monogram style, and thread color (if applicable) and confirm that it is entered correctly</h4></div> ');
            $('#uaID').on('change', function() {
                if ((this.checked) && flagStop != "1" && MonogramText != "") {
                    $('#btn add-to-cart').prop('disabled', false);
                    $('input#MonogramText').on('click', uncheckAll);

                } else {
                    $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
                }
            });
            //unchecks agreement once MonogramTextbox is clicked
            function uncheckAll() {
                $("#uaID:checked").prop("checked", false);
                $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
            }

        }
        //----UserAgreement changed 06/26 #JDG  -----End          

        //-----------------------------------
        //Button close
        //-----------------------------------  

        $("#btnClose").click(function() {
            //Reset Values
            $("#addtocart").addClass('disabled').attr('disabled', 'disabled');
            $("#threadcolor option").attr('selected', false).first().attr('selected', true);
            $('select[name="properties[Monogram Style]"] option').attr('selected', false).first().attr('selected', true);
            $("#monogramimage").val(''); //clear the monogram

            if (MonogramText !== "***") {
            $('#MonogramText').val(''); //clear monogram text
            }

            flagStop = "";
        });


        //-----------------------------------
        //Add to cart
        //-----------------------------------         
        //Working SENDING SOLD TAG but currently we use
        $('#addtocart').on('click', function(event) {

            if (!$('#uaID').is(':checked')) {
                event.stopImmediatePropagation();
                event.preventDefault();
                return false;
            }

            window.setTimeout(function() {
                $("#btnClose").click();
                $("#uaID:checked").prop("checked", false);
            }, 500);

        });

    });